import { User } from "interfaces/user";

export enum CaseStreamItemType {
  EVENT = "event",
  ASSIGNEE = "assignee",
  WORK_ORDER = "work_order",
  CASE_ACTION = "case_action",
  PROJECT = "project"
}

export interface CaseStreamItem {
  item_id: string;
  entity_id: number;
  item_type: CaseStreamItemType;
  datetime: string;
  user: User;
  description: string;
}
export interface CaseStreamResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: CaseStreamItem[];
}
